module.exports = __webpack_public_path__ + "img/Alrick.7ba24b9c.jpg";